// Modèles de publication Facebook prêts à l'emploi, par secteur.
// Chaque modèle pré-remplit le titre + le texte, puis reste modifiable avant publication.
// `match` = mots-clés pour remonter en premier les modèles du secteur du commerçant.
export const FB_TEMPLATES = [
  {
    sector: "Restaurant / Café",
    post_type: "offre",
    match: ["restaur", "café", "cafe", "bar", "brasserie", "pizz", "food", "traiteur", "boulang", "pâtiss"],
    title: "Le menu du midi vous attend 🍽️",
    text: "Cette semaine chez nous, c'est [plat du jour] à [prix] !\n\nProduits frais, faits maison, et toujours le sourire. Réservez votre table au [téléphone] ou passez nous voir au [adresse].\n\nÀ très vite 😊",
  },
  {
    sector: "Restaurant / Café",
    post_type: "evenement",
    match: ["restaur", "café", "cafe", "bar", "brasserie", "pizz", "food"],
    title: "Soirée spéciale ce [jour] soir !",
    text: "On vous prépare une [soirée à thème] le [date] à partir de [heure] 🎉\n\nAu programme : [ambiance / animation]. Places limitées, pensez à réserver au [téléphone].\n\nOn a hâte de vous recevoir !",
  },
  {
    sector: "Beauté / Coiffure",
    post_type: "offre",
    match: ["coiff", "beaut", "beaute", "esthé", "esthe", "ongle", "spa", "barbier", "institut", "massage"],
    title: "Offrez-vous une pause beauté ✨",
    text: "Ce mois-ci, profitez de [offre, ex. -20% sur les soins] chez [nom du salon] !\n\nPrenez rendez-vous au [téléphone] ou en ligne. On s'occupe de tout 💆\n\n[adresse]",
  },
  {
    sector: "Commerce / Boutique",
    post_type: "nouveau_produit",
    match: ["boutique", "magasin", "mode", "prêt", "pret", "déco", "deco", "fleur", "bijou", "cadeau", "commerce"],
    title: "Nouveauté en boutique 🛍️",
    text: "On vient de recevoir [nouveau produit / collection] !\n\nVenez les découvrir en magasin, on vous conseille avec plaisir.\n\n📍 [adresse] · ☎️ [téléphone]\nHoraires : [horaires]",
  },
  {
    sector: "Commerce / Boutique",
    post_type: "offre",
    match: ["boutique", "magasin", "mode", "commerce", "alimentation", "épicer", "epicer"],
    title: "Bon plan de la semaine 🎁",
    text: "[Produit / service] à [prix barré → nouveau prix] jusqu'à [date] !\n\nUne occasion à ne pas manquer. On vous attend en boutique au [adresse].",
  },
  {
    sector: "Artisan / Services",
    post_type: "actualite",
    match: ["artisan", "plomb", "électric", "electric", "menuis", "peintre", "garage", "auto", "bâtiment", "batiment", "service", "chauffage", "jardin", "maison"],
    title: "Votre artisan local à votre service 🔧",
    text: "Besoin de [prestation] ? [Nom] intervient à [ville et alentours] pour un travail soigné et un devis gratuit.\n\nContactez-nous au [téléphone] — réponse rapide garantie.",
  },
  {
    sector: "Association / Club",
    post_type: "actualite",
    match: ["associ", "club", "sport", "culture", "amicale"],
    title: "Rejoignez-nous ! 🤝",
    text: "[Nom de l'association / du club] accueille de nouveaux membres pour la saison [année] !\n\nActivités : [liste]. Ambiance conviviale et ouverte à tous.\n\nInfos & inscriptions : [téléphone / lien]. On vous attend 💙",
  },
  {
    sector: "Association / Club",
    post_type: "evenement",
    match: ["associ", "club", "sport", "culture", "amicale"],
    title: "Notre prochain rendez-vous 📅",
    text: "Nous organisons [événement] le [date] à [lieu] !\n\n[Description courte]. Entrée [libre / tarif]. Venez nombreux et partagez autour de vous !",
  },
  {
    sector: "Événement",
    post_type: "evenement",
    match: ["event", "événement", "evenement", "spectacle", "concert", "loisir"],
    title: "Save the date 🎉",
    text: "[Nom de l'événement] — le [date] à [heure], [lieu].\n\n[Ce qui vous attend]. Infos pratiques : [parking / accès / tarif].\n\nPartagez avec vos proches !",
  },
  {
    sector: "Promo / Déstockage",
    post_type: "offre",
    match: ["promo", "soldes", "déstock", "destock"],
    title: "Grosses promos en ce moment ! 💥",
    text: "C'est le moment de faire de bonnes affaires chez [nom] : jusqu'à [-X%] sur [sélection] !\n\nJusqu'au [date] seulement. Premiers arrivés, premiers servis.\n\n📍 [adresse]",
  },
];

/** Classe les modèles : d'abord ceux du secteur du commerçant (ou asso/club selon le rôle). */
export function orderTemplates(entity) {
  const kind = entity?.kind;
  const hay = `${entity?.sector || ""} ${entity?.name || ""}`.toLowerCase();
  const isOrg = kind === "club" || kind === "association" || kind === "organization";
  return FB_TEMPLATES
    .map((t, i) => {
      let score = 0;
      if ((t.match || []).some((m) => hay.includes(m))) score += 10;
      if (isOrg && /association|club/i.test(t.sector)) score += 8;
      return { t, i, score };
    })
    .sort((a, b) => b.score - a.score || a.i - b.i)
    .map((s) => s.t);
}
